export default __webpack_public_path__ + "static/HeroSectionLeft_uk-d1948b32175c09c36acbc9f9fca14792.png";